import React, {useContext} from "react";
import {Image} from "react-bootstrap";
import {LogOut, RefreshCw, ShieldOff} from "lucide-react";

import "./NoAccess.css";

import {KeycloakContext} from "@context/KeycloakContext.jsx";
import Button from "@components/Button/Button";
import NavLogo from "@assets/logos/nav-logo4.svg";

export default function NoAccess() {
    const {user, userType, logout} = useContext(KeycloakContext);

    const organization =
        user?.customer?.name ?? user?.partner?.name ?? (user?.company === "netcyberops" ? "NetCyberOps" : user?.company);

    const contactLine =
        userType === "employee"
            ? "Ask a NetCyberOps administrator to assign you a role."
            : `Ask an administrator${organization ? ` at ${organization}` : ""} to assign you a role. If nobody at your organization can do that, contact your NetCyberOps representative.`;

    return (
        <div className="no-access-page">
            <div className="no-access-card">
                <Image src={NavLogo} className="no-access-logo" fluid/>

                <div className="no-access-icon">
                    <ShieldOff size={24}/>
                </div>

                <h1 className="no-access-title">You do not have access yet</h1>

                <p className="no-access-lead">
                    Your sign-in succeeded, but this account has no roles assigned. Access is granted through roles, and yours have either not been set up yet or have
                    been removed.
                </p>
                <p className="no-access-lead">{contactLine}</p>

                <dl className="no-access-meta">
                    <div className="no-access-meta-row">
                        <dt>Signed in as</dt>
                        <dd>{user?.email ?? "—"}</dd>
                    </div>
                    {organization && (
                        <div className="no-access-meta-row">
                            <dt>Organization</dt>
                            <dd>{organization}</dd>
                        </div>
                    )}
                    <div className="no-access-meta-row">
                        <dt>Access</dt>
                        <dd>
                            <span className="no-access-badge">No roles assigned</span>
                        </dd>
                    </div>
                </dl>

                <div className="no-access-actions">
                    <Button
                        variant="primary"
                        size="md"
                        icon={<RefreshCw size={15}/>}
                        onClick={() => window.location.reload()}
                        id="no-access-refresh-btn"
                    >
                        Refresh
                    </Button>
                    <Button
                        size="md"
                        icon={<LogOut size={15}/>}
                        onClick={logout}
                        id="no-access-signout-btn"
                    >
                        Sign out
                    </Button>
                </div>
            </div>
        </div>
    );
}
